import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function MeetRequestsPage() {
  return (
    <InteractionList
      type={InteractionTypes.MEET_REQUEST}
      direction="bidirectional"
      title="Rendez-vous reçus / demandés"
      emptyMessage="Aucune demande de rendez-vous pour le moment."
    />
  );
}
